import { officeTaskCreateModalTypes as T } from "../actions/officeTaskCreateModal.actions";

const initialState = {
    open: false,
    officeId: "",
    source: "",
    sourceTitle: "",
    prefill: {},
    openedAt: null,
};

export default function officeTaskCreateModalReducer(state = initialState, action) {
    switch (action.type) {
        case T.OPEN:
            return {
                ...state,
                open: true,
                officeId: action.payload?.officeId || "",
                source: action.payload?.source || "",
                sourceTitle: action.payload?.sourceTitle || "",
                prefill: action.payload?.prefill || {},
                openedAt: action.payload?.openedAt || Date.now(),
            };

        case T.CLOSE:
            return {
                ...initialState,
            };

        default:
            return state;
    }
}
